var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Heart = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 1004.33 809.58", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M937.92 66.41a226.76 226.76 0 0 0-320.67 0l-92.46 92.46a32 32 0 0 1-45.25 0l-92.46-92.46A226.75 226.75 0 0 0 66.41 387.08l413.13 413.13A32 32 0 0 0 524.79 755L111.67 341.83c-63.46-63.46-63.46-166.71 0-230.16a162.74 162.74 0 0 1 230.16 0l92.45 92.45a96 96 0 0 0 135.77 0l92.45-92.45a162.74 162.74 0 0 1 230.16 0c63.46 63.45 63.46 166.7 0 230.16L575.54 659a32 32 0 0 0 45.25 45.26l317.13-317.18a226.76 226.76 0 0 0 0-320.67z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default Heart;
//# sourceMappingURL=Heart.js.map